export const CreateCampaignType = {
  priceDiscountInBasket: {
    value: 'price_discount',
    i18nKeySuffix: 'priceDiscountInBasket',
  },
  percentDiscountInBasket: {
    value: 'percentage_discount',
    i18nKeySuffix: 'percentDiscountInBasket',
  },
  getXPayY: {
    value: 'buy_x_pay_y',
    i18nKeySuffix: 'getXPayY',
  },
  buyALotPayLess: {
    value: 'buy_more_pay_less',
    i18nKeySuffix: 'buyALotPayLess',
  },
  takeItTogether: {
    value: 'bundle',
    i18nKeySuffix: 'takeItTogether',
  },
  discountOnTheXthItem: {
    value: 'product_discount',
    i18nKeySuffix: 'discountOnTheXthItem',
  },
};

export const getCampaignTypeOptions = (t: (key: string) => string, i18nKeyPrefix: string) =>
  Object.values(CreateCampaignType).map((campaignType) => ({
    value: campaignType.value,
    tip: `Açıklama: ${t(`${i18nKeyPrefix}.${campaignType.i18nKeySuffix}`)}`,
    label: t(`${i18nKeyPrefix}.${campaignType.i18nKeySuffix}`),
  }));
